"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDownOutline = _interopRequireDefault(require("./IconArrowDownOutline"));
var IconArrowRightOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDownOutline.default).withConfig({
  displayName: "IconArrowRightOutline",
  componentId: "c11n-8-107-0__sc-a71fta-0"
})(["transform:rotate(270deg);"]);
var _default = IconArrowRightOutline;
exports.default = _default;